import { useQuery } from "@tanstack/react-query";
import { createRef, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getCommonCertificates } from "../../../../../core/api/services/dms.certificate.service";
import capitalizeFirst from "../../../../../shared/helpers/upper-case";

import { B2Button } from "src/shared/@hdb/biome-2";

import ModalComponent from "src/core/components/modal/modal.component";
import FormBuilderComponent, {
  FormConfig,
} from "src/shared/form-builder/form-builder.component";
import {
  addCommonCertificate,
  getCommonCertificateFile,
  regenarateCommonCertificate,
} from "src/store/slices/certificate.slice";

import HasPermission from "src/core/guards/has-permission";
import { dateTimeToDateYYYYMMDD } from "src/shared/helpers/dateTime-to-date";
import * as yup from "yup";

const DMSCommonCertificateComponent = (props: any) => {
  const formRef = createRef();
  const formRefRegenerate = createRef();
  const [PageNumber, setPageNumber] = useState<number>(1);
  const [dmsCommonCerSearchValue, setdmsCommonCerSearchValue] = useState("");
  const pageSize = 10;

  // const [SortBy, setSortBy] = useState<any>(capitalizeFirst("commonName"));
  // const [SortDirection, setSortDirection] = useState<any>("desc");
  const [SortBy] = useState<any>(capitalizeFirst("commonName"));
  const [SortDirection] = useState<any>("desc");

  const [isTableModalOpen, setIsTableModalOpen] = useState<boolean>(false);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  // const [isAdd, setIsAdd] = useState<boolean>(false);
  const [isDownload, setIsDownload] = useState<boolean>(false);
  const [wrongDate, setWrongDate] = useState(false);

  const dispatch = useDispatch();
  // const [initialValues, setInitialValues] = useState<any>({
  //   commonName: "",
  //   expireDate: "",
  // });
  const [initialValues] = useState<any>({
    commonName: "",
    expireDate: "",
  });

  const today = new Date();
  today.setHours(0, 0, 0, 0); // Set the time component to 00:00:00 to compare only the date part

  const [initialValuesRegenerate, setInitialValuesRegenerate] = useState<any>({
    commonName: "",
    expireDate: "",
  });

  // const validationSchema = yup.object().shape({
  //   commonName: yup.string().required("Common Name is required"),
  //   expireDate: yup.string().required("Expire Date is required"),
  // });

  // const validationSchemaRegenerate = yup.object().shape({
  //   commonName: yup.string().required("Common Name is required"),
  //   expireDate: yup.string().required("Expire Date is required"),
  // });

  const validationSchemaRegenerate = yup.object().shape({
    commonName: yup.string().required("Common Name is required"),

    expireDate: yup
      .string()
      .required("Expire Date is required")
      .test(
        "not-before-today",
        "Expire Date cannot be in the past",
        (value) => {
          if (!value) return false; // In case the value is null or undefined

          const [year, month, day] = value.split("-").map(Number);
          const parsedDate = new Date(year, month - 1, day);
          parsedDate.setHours(0, 0, 0, 0); // Set the time component to 00:00:00 to compare only the date part

          if (parsedDate < today) setWrongDate(true);
          else setWrongDate(false);

          return parsedDate >= today;
        }
      ),
  });

  /*   const [columns, setColumns] = useState([
      {
        title: "Common Name",
        label: "commonName",
        isSorted: true,
        // width: "22rem",
        type: "text",
      },
      {
        title: "Expired Date",
        label: "expireDate",
        type: "date",
        width: "14rem",
      },
    ]); */

  const {
    data: commenCertificates,
    isLoading: isLoadingCommonCertificates,
    refetch,
  } = useQuery({
    queryKey: [
      "getCommonCertificates",
      PageNumber,
      SortBy,
      SortDirection,
      dmsCommonCerSearchValue,
    ],
    queryFn: ({ signal }) =>
      getCommonCertificates(
        PageNumber,
        pageSize,
        SortBy,
        SortDirection,
        dmsCommonCerSearchValue,
        signal
      ),
  });

  const onRefetchData = () => {
    if (commenCertificates?.numberOfRecords <= pageSize + 1) {
      setPageNumber(1);
    }
    void refetch();
  };

  const [isRegenerate, setIsRegenerate] = useState(false);

  const [commonName, setCommonName] = useState("");
  const [expireDate, setExpireDate] = useState("");

  const [updateForm, setUpdateForm] = useState(0);

  useEffect(() => {
    if (!commenCertificates) return;

    const expDate = dateTimeToDateYYYYMMDD(
      commenCertificates?.data?.expireDate
    );

    if (!expDate) return;
    setCommonName(commenCertificates?.data.commonName);

    setExpireDate(expDate);

    setIsRegenerate(true);

    setInitialValuesRegenerate({
      commonName: commenCertificates?.data.commonName,
      expireDate: expDate,
    });

    setUpdateForm(updateForm + 1);
  }, [commenCertificates]);

  /*   const handleChangePage = useCallback((page: number): void => {
      setPageNumber(page);
    }, []); */

  /*   const handleChangeSort = useCallback(
      async (sortBy: string, sortDirection: any) => {
        if (!sortBy || !sortDirection) return;
        setSortBy(sortBy);
        setSortDirection(sortDirection);
  
        const copyColumns: any = await TableSort(columns, sortBy);
        setColumns(copyColumns);
      },
      []
    ); */

  /*   const handleSearch = useCallback((searchVal: string): void => {
      setPageNumber(1);
      setdmsCommonCerSearchValue(searchVal);
    }, []); */

  /*   const emptyConfig = {
      title: "No Certificate Found",
      description: "",
    }; */

  /*   const revokeAction = (commonName: string) => {
      setIsAdd(false);
      setIsDownload(false);
      setIsRegenerate(true);
      setIsModalOpen(true);
      setIsTableModalOpen(false);
  
      // setSelectedCommonNameToPerformAction(commonName);
    }; */

  const downloadAction = (commonName: string) => {
    // setIsAdd(false);
    setIsDownload(true);
    // setIsRegenerate(false);
    setIsModalOpen(true);
    setIsTableModalOpen(false);

    // setSelectedCommonNameToPerformAction(commonName);
  };

  /*   const isDisabledButton = (data: any, label: any): boolean => {
      if (data && data?.isRevoked) {
        if (["Download", "Revoke"].includes(label)) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    }; */

  const actionConfig: any = [
    {
      label: "Download",
      event: downloadAction,
      variant: "secondary",
    },
    // {
    //   label: "Regenerate",
    //   event: revokeAction,
    //   variant: "info",
    // },
  ];

  const handleCloseParentModal = () => {
    // setIsAdd(false);
    setIsRegenerate(false);
    setIsDownload(false);
    setIsTableModalOpen(false);

    if (props.handelCloseModel) {
      props.handelCloseModel(false);
    }

    setWrongDate(false);
    // setInitialValues({
    //   commonName: "",
    //   expireDate: "",
    // });

    // setInitialValuesRegenerate({
    //   commonName: "",
    //   expireDate: "",
    // });
  };

  const handleCloseModal = () => {
    setdmsCommonCerSearchValue("");
    // setIsAdd(false);
    // setIsRegenerate(false);
    setIsDownload(false);
    setIsModalOpen(false);

    setIsTableModalOpen(true);

    // setInitialValues({
    //   commonName: "",
    //   expireDate: "",
    // });

    // setInitialValuesRegenerate({
    //   commonName: "",
    //   expireDate: "",
    // });
  };

  const onSubmit = () => {
    const form: any = formRef.current;

    if (form) {
      const { expireDate, commonName } = form?.values || {};

      form.handleSubmit();

      if (!expireDate || !commonName || wrongDate) {
        return;
      }

      dispatch(addCommonCertificate({ payload: form.values })).then(() => {
        handleCloseModal();
        onRefetchData();
      });
    }

    if (props.handelCloseModel) {
      props.handelCloseModel(false);
    }
  };

  const handleRevokeOk = () => {
    const form: any = formRefRegenerate.current;
    form.handleSubmit();

    const { commonName, expireDate } = form.values;

    if (!expireDate || !commonName || wrongDate) return;

    const data = {
      commonName: commonName,
      expireDate: expireDate,
    };

    dispatch(regenarateCommonCertificate({ payload: data }));

    setdmsCommonCerSearchValue("");
    // setIsAdd(false);
    setIsRegenerate(false);
    setIsDownload(false);
    setIsModalOpen(false);
    setIsTableModalOpen(false);

    if (props.handelCloseModel) {
      props.handelCloseModel(false);
    }

    // dispatch(
    //   revokeCommonCertificate({ commonName: selectedCommonNameToPerformAction })
    // ).then(() => {
    //   onRefetchData();
    // });
  };

  const handleDownoadOk = () => {
    dispatch(
      getCommonCertificateFile({
        commonName: commonName,
      })
    );

    if (props.handelCloseModel) {
      props.handelCloseModel(false);
    }

    setdmsCommonCerSearchValue("");
    // setIsAdd(false);
    setIsRegenerate(false);
    setIsDownload(false);
    setIsModalOpen(false);
    setIsTableModalOpen(false);
  };

  let modalActionConfig: any = [
    {
      label: "Save",
      event: onSubmit,
      variant: "primary",
    },
  ];

  if (isDownload) {
    modalActionConfig = [
      {
        label: "Yes",
        event: handleDownoadOk,
        variant: "primary",
      },
    ];
  } else if (isRegenerate) {
    modalActionConfig = [
      {
        label: "Yes",
        event: handleRevokeOk,
        variant: "primary",
      },
    ];
  }

  const formConfig: FormConfig = {
    controls: [
      {
        name: "commonName",
        label: "Common Name",
        placeholder: "Common Name",
        type: "text",
        required: true,
      },
      {
        name: "expireDate",
        label: "Expire Date",
        placeholder: "Expire Date",
        type: "date",
        required: true,
      },
    ],
  };
  const formConfigRegenerate: FormConfig = {
    controls: [
      {
        name: "commonName",
        label: "Common Name",
        placeholder: "Common Name",
        type: "text",
        // disabled: true,
        required: true,
      },
      {
        name: "expireDate",
        label: "Expire Date",
        placeholder: "Expire Date",
        type: "date",
        required: true,
      },
    ],
  };

  useEffect(() => {
    setIsTableModalOpen(true);
  }, []);

  let commonCertificateButtonLabel = "Add Common Certificate";
  if (isLoadingCommonCertificates) {
    commonCertificateButtonLabel = "Loading...";
  }
  if (isRegenerate) {
    commonCertificateButtonLabel = "Regenerate";
  }

  let commonCertificateContent: any = "";

  if (isRegenerate) {
    commonCertificateContent = (
      <ul>
        <li>
          <strong>Common Name: </strong>
          {commonName}
        </li>
        <li>
          <strong>Expiry Date: </strong>
          {expireDate}
        </li>
      </ul>
    );
  } else if (!isLoadingCommonCertificates) {
    commonCertificateContent = <h2>No Common Certificate Found</h2>;
  }

  let modalHeaderTitle = "Add Common Certificate";
  if (isDownload) {
    modalHeaderTitle = "Download Certificates";
  } else if (isRegenerate) {
    modalHeaderTitle = "Confirm Regenerate Certificate";
  }

  const renderModalContent = () => {
    if (isDownload) {
      return (
        <h5 className="text-center">
          Confirm Download "<strong>{commonName}</strong>" Certificate?
        </h5>
      );
    }

    if (isRegenerate) {
      return (
        <FormBuilderComponent
          renderCount={updateForm}
          formRef={formRefRegenerate}
          initialValues={initialValuesRegenerate}
          validation={validationSchemaRegenerate}
          formConfig={formConfigRegenerate}
        />
      );
    }

    return (
      <FormBuilderComponent
        formRef={formRef}
        initialValues={initialValues}
        validation={validationSchemaRegenerate}
        formConfig={formConfig}
      />
    );
  };

  return (
    <>
      {isTableModalOpen && (
        <div>
          <div>
            <ModalComponent
              // isConformationModal={isRegenerate} // isDownload
              showModal={true}
              handleClose={handleCloseParentModal}
              headerTitle={"Common Certificate"}
              actionConfig={actionConfig}
            >
              <div className="my-3">
                <HasPermission
                  moduleName="Certificate"
                  actionName="Download-Certificate"
                  isRoute={false}
                >
                  <div className="d-flex gap-3 justify-content-between table-generic-action pb-3">
                    <div className="d-flex gap-3">
                      <B2Button
                        variant="primary"
                        onClick={() => {
                          // setIsAdd(true);
                          setIsModalOpen(true);
                          setIsTableModalOpen(false);
                        }}
                      >
                        {commonCertificateButtonLabel}
                      </B2Button>
                    </div>
                    {/* <SearchBarComponent
                  placeholder="Search Common Name"
                  methodToDispatch={getCertificates}
                  getSearch={handleSearch}
                /> */}
                  </div>
                </HasPermission>

                <div className="common-certificate">
                  {commonCertificateContent}
                </div>
                {/* <TableComponent
                  tableHeaders={columns}
                  emptyConfig={emptyConfig}
                  data={commenCertificates?.data}
                  totalNumberOfRecords={commenCertificates?.numberOfRecords}
                  pageSize={pageSize}
                  current={PageNumber}
                  onChangePage={handleChangePage}
                  actionConfig={actionConfig}
                  onChangeSort={handleChangeSort}
                  isLoadingData={isLoadingCommonCertificates}
                /> */}
              </div>
            </ModalComponent>
          </div>
        </div>
      )}

      {/* modals */}

      {isModalOpen && (
        <div>
          <ModalComponent
            isConformationModal={isRegenerate} // isDownload
            showModal={true}
            handleClose={handleCloseModal}
            headerTitle={modalHeaderTitle}
            actionConfig={modalActionConfig}
          >
            {renderModalContent()}
          </ModalComponent>
        </div>
      )}
    </>
  );
};

export default DMSCommonCertificateComponent;
